import React, { useState, useEffect, useRef } from "react";
import Icon from "./Icon";
import * as api from "../../../services/api";

function RenameModal({ file, onClose, onRenamed, showToast }) {
  const [newName, setNewName] = useState("");
  const [saving, setSaving] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (file) {
      setNewName(file.name || "");
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
          // Select name without extension
          const dotIndex = (file.name || "").lastIndexOf(".");
          if (dotIndex > 0) {
            inputRef.current.setSelectionRange(0, dotIndex);
          } else {
            inputRef.current.select();
          }
        }
      }, 100);
    }
  }, [file]);

  const handleRename = async () => {
    const trimmed = newName.trim();
    if (!trimmed || trimmed === file.name) {
      onClose();
      return;
    }

    setSaving(true);
    try {
      if (file.type === "folder") {
        // Folders don't have a rename API directly — show info
        showToast("info", "Folder rename coming soon. Use delete + create for now.");
        onClose();
        return;
      }

      const docId = file.id || file.item_id;
      await api.updateDocument(docId, { fileName: trimmed });
      showToast("success", `Renamed to "${trimmed}"`);
      onRenamed && onRenamed();
      onClose();
    } catch (err) {
      showToast("error", "Failed to rename: " + err.message);
    } finally {
      setSaving(false);
    }
  };

  if (!file) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <Icon name="pen" style={{ color: "#4285f4", fontSize: 18 }} />
          <h3>Rename</h3>
        </div>
        <form onSubmit={(e) => { e.preventDefault(); handleRename(); }}>
          <input
            ref={inputRef}
            className="modal-input"
            type="text"
            placeholder="Enter new name..."
            value={newName}
            onChange={(e) => setNewName(e.target.value)}
            onKeyDown={(e) => e.key === "Escape" && onClose()}
            maxLength={100}
          />
          <div className="modal-actions">
            <button type="button" className="modal-btn cancel" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-btn create" disabled={saving || !newName.trim()}>
              {saving ? "Renaming..." : "Rename"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RenameModal;
